






























import Vue from 'vue';
import {RouterAliases} from '@/router/routerAliases';
import IconLogout from '@components/svg/logout.vue';
import {logout} from '@/services/auth-shared';
import {useRouter} from '@/router';
import {computedNavItems} from './nav-items';

export interface NavItem {
  name: string;
  route: string;
}

export default Vue.extend({
  name: 'MainMenuWithPreferences',
  components: {
    IconLogout,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    navItems: {
      type: Array,
      default: () => [] as NavItem[],
    },
  },

  computed: {
    navItemsList() {
      return this.navItems && this.navItems?.length ? this.navItems : computedNavItems.value;
    },
    discoverRoute(): {name: string} {
      return {name: RouterAliases.DISCOVERY_VIEW};
    },
    myTripsRoute(): {name: string} {
      return {name: RouterAliases.MY_TRIPS_VIEW};
    },
    isAmexAuth(): boolean {
      return !!process.env.VUE_APP_AMEX_AUTH_ENABLED;
    },
    logoUrl(): string {
      return process.env.VUE_APP_MENU_LOGO || '/img/amex-logo.svg';
    },
    logoAltText(): string {
      return process.env.VUE_APP_TITLE || 'Mobi Agent Trip Planner';
    },
  },
  methods: {
    logout(): void {
      logout();
      const router = useRouter();
      router.replace({name: RouterAliases.AMEX_LANDING});
    },
  },
});
